//学段
const SectionDict = [
    {
        "code": 20,
        "name": "小学"
    },
    {
        "code": 30,
        "name": "初中"
    },
    {
        "code": 40,
        "name": "高中"
    }
]
const SectionJSON = list2Json(SectionDict)

//年级
const GradeDict = [
    {
        "code": 2010,
        "name": "一年级(上)"
    },
    {
        "code": 2011,
        "name": "一年级(下)"
    },
    {
        "code": 2020,
        "name": "二年级(上)"
    },
    {
        "code": 2021,
        "name": "二年级(下)"
    },
    {
        "code": 2030,
        "name": "三年级(上)"
    },
    {
        "code": 2031,
        "name": "三年级(下)"
    },
    {
        "code": 2040,
        "name": "四年级(上)"
    },
    {
        "code": 2041,
        "name": "四年级(下)"
    },
    {
        "code": 2050,
        "name": "五年级(上)"
    },
    {
        "code": 2051,
        "name": "五年级(下)"
    },
    {
        "code": 2060,
        "name": "六年级(上)"
    },
    {
        "code": 2061,
        "name": "六年级(下)"
    },
    {
        "code": 3010,
        "name": "七年级(上)"
    },
    {
        "code": 3011,
        "name": "七年级(下)"
    },
    {
        "code": 3020,
        "name": "八年级(上)"
    },
    {
        "code": 3021,
        "name": "八年级(下)"
    },
    {
        "code": 3030,
        "name": "九年级(上)"
    },
    {
        "code": 3031,
        "name": "九年级(下)"
    },
    {
        "code": 4010,
        "name": "高一(上)"
    },
    {
        "code": 4011,
        "name": "高一(下)"
    },
    {
        "code": 4020,
        "name": "高二(上)"
    },
    {
        "code": 4021,
        "name": "高二(下)"
    },
    {
        "code": 4030,
        "name": "高三(上)"
    },
    {
        "code": 4031,
        "name": "高三(下)"
    }
]
const GradeSON = list2Json(GradeDict)

//学科
const SubjectDict = [
    {
        "code": 10,
        "name": "语文"
    },
    {
        "code": 20,
        "name": "数学"
    },
    {
        "code": 30,
        "name": "英语"
    },
    {
        "code": 40,
        "name": "物理"
    },
    {
        "code": 50,
        "name": "历史"
    },
    {
        "code": 60,
        "name": "地理"
    },
    {
        "code": 70,
        "name": "政治"
    },
    {
        "code": 80,
        "name": "日语"
    },
    {
        "code": 90,
        "name": "社会"
    }
]
const SubjectSON = list2Json(SubjectDict)

//教材版本
const VersionDict = [
    {
        "code": 10,
        "name": "部编版"
    },
    {
        "code": 20,
        "name": "人教版"
    },
    {
        "code": 30,
        "name": "人教版(五四制)"
    },
    {
        "code": 40,
        "name": "浙教版"
    },
    {
        "code": 50,
        "name": "苏教版"
    },
    {
        "code": 60,
        "name": "沪教版"
    }
]
const VersionSON = list2Json(VersionDict)

export {SectionDict, GradeDict, SubjectDict, VersionDict, VersionSON,SubjectSON, GradeSON, SectionJSON}


function list2Json(list) {
    let json = {}
    list.map(item=>{
        json[item.code] = item.name
    })

    return json
}